import { render } from "./ThirdPersonPartial.html?vue&type=template&id=7bb9e030&scoped=true"
import script from "./ThirdPersonPartial.js?vue&type=script&lang=js"
export * from "./ThirdPersonPartial.js?vue&type=script&lang=js"

import "./ThirdPersonPartial.scss?vue&type=style&index=0&id=7bb9e030&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb9e030"]])

export default __exports__